<template>
  <div ref="containerRef">
    <div v-if="!isProduction" v-cloak>
      <div class="info">
        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
          "
        >
          <div>TEST CARD</div>
          <div>4242424242424242</div>
          <div>0428</div>
          <div>242</div>
        </div>
        <div style="display: flex; justify-content: center">
          <small
            ><a target="_blank" rel="noopener noreferrer" href="https://stripe.com/docs/testing"
              >Documentation</a
            ></small
          >
        </div>
      </div>
    </div>

    <div v-if="busy">Loading...</div>
    <div id="card-element" />
    <inline-alert v-if="cardErrors" :message="cardErrors" style="margin-top: 0.5rem"/>
  </div>
</template>
<script>
import { PaymentGatewayGetTokenError } from "../errors";
import { getDefaultStripeOptions } from "../common";
import InlineAlert from "./inline-alert.vue";

export default {
  components: {InlineAlert},
  data() {
    return {
      busy: null,
      stripe: null,
      card: null,
      cardErrors: null,
    };
  },
  methods: {
    initialize() {
      Promise.resolve()
        .then(this.setBusy)
        .then(this.createPaymentElement)
        .catch(this.handleError)
        .then(this.hideBusy);
    },

    setBusy() {
      this.$emit("loading", this.type, true);
      this.busy = true;
    },

    hideBusy() {
      this.$emit("loading", this.type, false);
      this.busy = false;
    },

    handleError(err) {
      console.error(err.message);
      this.onError(err.message);
    },

    createPaymentElement() {
      let stripeOptions = getDefaultStripeOptions();
      if (this.stripeAccount) {
        stripeOptions.stripeAccount = this.stripeAccount;
      }

      const stripe = Stripe(this.clientToken, stripeOptions);

      const styles = getComputedStyle(this.$refs.containerRef ?? document.body);
      const stripeStyles = {
        appearance: {
          theme: "stripe",
          variables: {
            colorText:  styles.getPropertyValue("--primary-text-color"),
            colorDanger: styles.getPropertyValue("--error-color"),
            fontFamily: `'Open Sans', sans-serif`,
            fontWeightNormal: 300,
            colorBackground: "#ffffff",
            borderRadius: '4px',
          },
          rules: {
            '.Input--invalid': {
              boxShadow: '0 0 2px var(--colorDanger)',
            },
          }
        },
        fonts: [
          {
            cssSrc: "https://fonts.googleapis.com/css?family=Open+Sans:300,400,400i,500,600&display=swap",
          },
        ]
      }
      
      const options = {
        paymentMethodCreation: "manual",
        currency: this.currency,
        ...this.stripeMode === "setup"
            ? {
              mode: "setup",
            } : {
              mode: "payment",
              amount: this.totalPriceInCents,
            },
        ...stripeStyles
      };
      const elements = stripe.elements(options);
      const paymentElement = elements.create("payment", {
        wallets: {
          applePay: this.enableApplePay ? "auto" : "never",
        },
      });

      paymentElement.mount("#card-element");

      paymentElement.addEventListener("change", (event) => {
        this.cardErrors = event.error ? event.error.message : null;
      });

      this.stripe = stripe;
      this.card = paymentElement;
      this.elements = elements;
    },

    validateCardType(paymentMethod) {
      if (this.allowAmericanExpress) {
        return paymentMethod;
      }

      const creditCardType =
        (paymentMethod && paymentMethod.card && paymentMethod.card.brand) || "";
      const isInvalid = creditCardType == "amex";

      if (isInvalid) {
        throw new PaymentGatewayGetTokenError(
          "American Express Credit Cards are not accepted"
        );
      }

      return paymentMethod;
    },

    getToken() {
      return Promise.resolve()
        .then(() => this.elements.submit())
        .then(({ error }) => {
          if (error) throw new PaymentGatewayGetTokenError(error.message);
        })
        .then(() =>
          this.stripe.createPaymentMethod({
            elements: this.elements,
          })
        )
        .then(({ paymentMethod, error }) => {
          if (error) {
            throw new PaymentGatewayGetTokenError(error.message);
          }
          if (!paymentMethod) {
            throw new Error(
              "Stripe did not return a payment method with successful response."
            );
          }
          return paymentMethod;
        })
        .then(this.validateCardType)
        .then((paymentMethod) => {
          return paymentMethod.id;
        })
        .catch((exception) => {
          this.cardErrors = exception.message;
          throw exception;
        });
    },
  },

  mounted() {
    this.initialize();
  },

  props: {
    clientToken: {
      type: String,
      required: true,
    },
    stripeAccount: {
      type: String,
    },
    stripeMode: {
      type: String,
      default: "payment",
    },
    isProduction: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    onError: {
      type: Function,
      required: true,
    },
    allowAmericanExpress: {
      type: Boolean,
    },
    totalPriceInCents: {
      type: Number,
    },
    currency: {
      type: String,
      required: true,
    },
    enableApplePay: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
